// import Lottie from "react-lottie";
// import React from "react";
// import loader from "../../assets/json/loader.json";
// const defaultOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: loader,
//   rendererSettings: {
//     preserveAspectRatio: "xMidYMid slice"
//   }
// };
// // eventListeners={[
// //         {
// //             eventName: 'complete',
// //             callback: () => window.location.reload(),
// //         },
// // ]}

// const Loader = props => {
//   return (
//     <div>
//       <Lottie
//         options={defaultOptions}
//         height={props.height ? props.height : 50}
//         width={props.width ? props.width : 50}
//         style={props.style ? props.style : {}}
//       />
//     </div>
//   );
// };
// export default Loader;




import React from "react";
import { useLottie } from "lottie-react";
import loader from "../../assets/json/loader.json";

const Loader = () => {
  const options = {
    animationData: loader,
    loop: true
  };

  const { View } = useLottie(options);

  return <div style={{width:"40px",height:"40px"}}>{View}</div>;
};

export default Loader;